import { ItemOption } from 'components/FormInputSelect'
import { AddressType } from 'types/address.type'
import { BaseData } from 'types/base.type'
import { CityResponse } from 'types/city.type'
import { StateResponse } from 'types/state.type'
import client from './client'

class AddressService {
  getAllFullNameStates = async (): Promise<BaseData<ItemOption[]>> => {
    const url = `/estados`

    return await client.get<BaseData<StateResponse[]>>(url).then((res) => {
      const response: BaseData<ItemOption[]> = {
        data: res.data.map((item) => ({
          value: String(item.id),
          label: item.nome,
        })),
        status: res.status,
      }

      return response
    })
  }

  getAllStateAcronyms = async (): Promise<BaseData<ItemOption[]>> => {
    const url = `/estados`

    return await client.get<BaseData<StateResponse[]>>(url).then((res) => {
      const response: BaseData<ItemOption[]> = {
        data: res.data.map((item) => ({
          value: String(item.id),
          label: item.sigla,
        })),
        status: res.status,
      }

      return response
    })
  }

  getAllCitiesByStateId = async (stateId: string): Promise<BaseData<ItemOption[]>> => {
    const url = `/municipio`

    const params = {
      idEstado: stateId,
    }

    return await client.get<BaseData<CityResponse[]>>(url, params).then((res) => {
      const response: BaseData<ItemOption[]> = {
        data: res.data.map((item) => ({
          value: String(item.id),
          label: item.nome,
        })),
        status: res.status,
      }

      return response
    })
  }

  getAllNeighbourhoodByCityId = async (cityId?: string): Promise<BaseData<ItemOption[]>> => {
    const url = `/bairro/${cityId}`

    return await client.get<BaseData<ItemOption[]>>(url).then((res) => res)
  }

  getByZipCode = async (zipCode: string): Promise<BaseData<AddressType>> => {
    const url = `/cep`

    const params = {
      nroCep: zipCode,
    }

    return await client.get<BaseData<AddressType>>(url, params).then((res) => res)
  }
}

export default new AddressService()
